import { render, staticRenderFns } from "./AgentPermissionsList.vue?vue&type=template&id=0f541382"
import script from "./AgentPermissionsList.vue?vue&type=script&lang=js"
export * from "./AgentPermissionsList.vue?vue&type=script&lang=js"
import style0 from "./AgentPermissionsList.vue?vue&type=style&index=0&id=0f541382&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports